import { Controller } from "@hotwired/stimulus"

// Polls /configuracoes/integra/status.json every 2s while status is pending.
// Stops when status changes or after 60s timeout.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timeoutAt = Date.now() + 60_000
    this.boundPoll = this.poll.bind(this)
    this.boundStart = this.startPolling.bind(this)
    document.addEventListener("integra:test-started", this.boundStart)
  }

  disconnect() {
    this.stopPolling()
    document.removeEventListener("integra:test-started", this.boundStart)
  }

  startPolling() {
    this.stopPolling()
    this.timeoutAt = Date.now() + 60_000
    this.intervalId = setInterval(this.boundPoll, 2000)
    this.poll()
  }

  stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  async poll() {
    if (Date.now() > this.timeoutAt) {
      this.stopPolling()
      return
    }
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      if (data.status !== "pending") {
        this.stopPolling()
        location.reload()
      }
    } catch (e) {
      // erro de rede transitório — próxima tick tenta de novo
    }
  }
}
